/* eslint-disable react-hooks/exhaustive-deps */
import { exists, translateWithParams } from "application/functions";
import modifyRepetibleIndex from "module/functions/modifyRepetibleIndex";
import validateGarments from "module/functions/validateGarments";
import validateData from "module/functions/validateData";
import validateAddress from "module/functions/validateAddress";
import PayPalComponent from "./paypal-component";
import { map, has } from "ramda";
import React, { Fragment, useEffect, useState } from "react";
import useForm from "react-hook-form";
import Button from "./inputs/button";
import StepTitle from "./step-title";
import GarmentManager from "./garment/garment-manager";
import UserData from "./user/user-data";
import UserAddress from "./user/user-address";
import DropPoint from "./drop-point/drop-point";
import FinalStep from "./final-step/final-step";
import ErrorMessage from "./error-message/error-message";
import { translate } from "application/functions";
import {
  SHIPPING_COST,
  URL_BACK_PREF,
  URL_BACK_SUF,
  URL_CLOSE_APP,
  URL_OK,
  URL_OK_FR,
} from "application/constants/app-constants";
import logo from "assets/img/zarapreowned.svg";
import back from "assets/img/back.png";
import Close from "assets/img/black-cancel.svg";
import IcoFacebook from "assets/img/ico-facebook.svg";
import IcoTwitter from "assets/img/ico-twitter.svg";
import IcoPhone from "assets/img/ico-phone.svg";
import ArrowHelp from "assets/img/arrow-help.svg";
import whatsapp from "assets/img/ico-whatsapp.svg";
import ReactModal from "react-modal";
import getIsApp from "module/functions/getIsApp";
import getCurrency from "module/functions/getCurrency";
import getCountry from "module/functions/getCountry";
import getLang from "module/functions/getLang";
import { useRef } from "react";
import Loading from "application/components/loading";

const Form = (props) => {
  const { form, defaultValue, onSubmit, changeAnswer, deletedProducts, setDeletedProducts, createdAnswerId, loading } =
    props;
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [step, setStep] = useState(0);
  const [onFocus, setOnFocus] = useState(false);
  const [windowSize, setWindowSize] = useState(getWindowSize());

  const currency = getCurrency();

  const country = getCountry();

  const lang = getLang() || navigator.language || navigator.userLanguage;

  function getWindowSize() {
    const { innerWidth } = window;
    return { innerWidth };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  const toMatch = [/webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  const toMatchWhatsapp = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  const userAgentApp = [/ZaraApp/i, /iPhone/i, /iPad/i, /iPod/i];
  const userAgentIOS = [/iPhone/i, /iPad/i, /iPod/i];
  function detectMob(values) {
    return values.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
  const isMobileBrowserQuitAndroid = detectMob(toMatch);
  const isMobileBrowser = detectMob(toMatchWhatsapp);
  const isApp = detectMob(userAgentApp);
  const isIOS = detectMob(userAgentIOS);

  const { register, handleSubmit, setValue, watch, reset } = useForm();
  const formValues = watch();

  const [arrangementsPrice, setArrangementsPrice] = useState(0);
  const [arrangementsPriceWithoutDiscount, setArrangementsPriceWithoutDiscount] = useState(0);
  const [arrangementsDiscount, setArrangementsDiscount] = useState(0);

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue, reset]);

  const setSelectValue = (path, value) => {
    setValue(path, value);
  };

  const incrementStep = () => {
    const newStep = step + 1;
    setStep(newStep);
    setDisabled(false);
  };

  const validateBeforeSubmit = (value) => {
    setErrors({});
    setDisabled(true);
    if (step === 0) {
      const hasErrors = validateGarments(formValues, deletedProducts);
      if (exists(hasErrors)) {
        setErrors(hasErrors);
        window.scrollTo(0, 0);
        setDisabled(false);
        return;
      }
      incrementStep();
    }
    if (step === 1) {
      const hasErrors = validateData(formValues);
      if (exists(hasErrors)) {
        setErrors(hasErrors);
        window.scrollTo(0, 0);
        setDisabled(false);
        return;
      }
      incrementStep();
    }
    if (step === 2) {
      setDisabled(false);
      incrementStep();
    }
    if (step === 3) {
      const hasErrors = validateAddress(formValues);
      if (exists(hasErrors)) {
        setErrors(hasErrors);
        window.scrollTo(0, 0);
        setDisabled(false);
        return;
      }
      handleSubmit((data) => {
        data.paypal_transaction_id = { value: "-" };
        const newValue = modifyRepetibleIndex(
          data,
          SHIPPING_COST + arrangementsPrice,
          form.withDiscount
            ? {
                arrangementsPriceWithoutDiscount: arrangementsPriceWithoutDiscount + SHIPPING_COST,
                arrangementsDiscount,
              }
            : null
        );
        onSubmit(newValue);
        incrementStep();
      })();
    }
    if (step === 4) {
      incrementStep();
      return;
    }
  };

  const [dataPaypal, setDataPaypal] = useState([]);

  const transactionComplete = (details, name) => {
    const id = details.purchase_units[0].payments.captures[0].id;
    // const name = details.payer.name.given_name;
    const money = details.purchase_units[0].amount.value;
    setDataPaypal([id, name]);
    changeAnswer(id, money);
    //PUBLISHED
    const newStep = step + 1;
    setStep(newStep);
  };

  const stepBack = () => {
    if (step === 0) {
      const url_country = `${country === "fr" ? "fr" : "uk"}`;
      const url_lang = `/${lang === "fr" ? "fr" : "en"}`;
      const url_back = `${URL_BACK_PREF}${url_country}${url_lang}${URL_BACK_SUF}`;
      window.location.href = getIsApp() ? URL_CLOSE_APP : url_back;
    } else {
      const newStep = step - 1;
      setStep(newStep);
    }
  };

  const startAgain = () => {
    const redirectURL = country === "fr" ? URL_OK_FR : URL_OK;
    window.location.href = getIsApp() ? URL_CLOSE_APP : redirectURL;
  };

  const [modalIsOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
    setModalOpen(false);
  };

  const afterOpenModal = () => {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  };
  const time = new Date();

  const timeParameters = {
    day: time?.getDate() >= 21 && time.getDate() <= 29,
    mont: time?.getMonth() + 1 === 11,
  };

  const showBFWarning = Object.values(timeParameters).every((value) => value === true);

  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  const handleResize = () => {
    const screenHeight = window.innerHeight;
    const mobileHeight = window.screen.height;
    if (screenHeight < mobileHeight * 0.7) {
      setIsKeyboardOpen(true);
    } else {
      setIsKeyboardOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fixButtonPosition = isKeyboardOpen && isMobileBrowser && windowSize.innerWidth < 1024;

  const createdAnswerIdRef = useRef(null);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    createdAnswerIdRef.current = createdAnswerId;
    if (exists(createdAnswerIdRef.current)) {
      setShowError(has("error", createdAnswerIdRef.current));
    }
  }, [createdAnswerId]);

  const getRepairsPriceName = () => {
    const numberRepairs = document.querySelectorAll(".tocalculate .select-field-combo-input__main-field")?.length ?? 1;

    if (numberRepairs === 1) {
      return translate("summary.repairs.singular");
    }
    return translateWithParams("summary.repairs.plural", { numberRepairs });
  };

  return (
    <Fragment>
      {loading && <Loading />}
      {showError ? (
        <ErrorMessage />
      ) : (
        <>
          <form onSubmit={handleSubmit(validateBeforeSubmit)} autoComplete="off" className="form__form-component">
            <div className="form__form-app">
              <div className="form__form-back" onClick={() => stepBack()}>
                {step < 5 && <img src={getIsApp() && step === 0 ? Close : back} alt="back" />}
              </div>
              <div className="form__form-header">
                <img className={`form_form-logo ${step === 5 ? "last_step" : ""}`} src={logo} alt="logo" />

                <div className="form__form-help">
                  {step === 0 && (
                    <div
                      onClick={(e) => {
                        if (country !== "fr") {
                          setModalOpen(true);
                        } else {
                          window.location = "https://www.zara.com/fr/fr/contact?topic=generalQuestions";
                        }
                      }}
                    >
                      {translate("help")}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="form__form-wrapper">
              <StepTitle step={step} />
              {showBFWarning && step === 4 && (
                <p style={{ marginBottom: "30px", lineHeight: "1.5" }}>{translate("black.friday")}</p>
              )}
            </div>
            <div style={{ display: step !== 1 ? "block" : "none" }}>
              {map(
                (message) => (
                  <div className="form__form-wrapper">
                    <div key={message} className="error-text">
                      {message}
                    </div>
                  </div>
                ),
                errors?.messages ?? []
              )}
            </div>
            <GarmentManager
              form={form}
              register={register}
              setSelectValue={setSelectValue}
              defaultValue={defaultValue}
              errors={errors}
              display={step === 0}
              setArrangementsPrice={setArrangementsPrice}
              setArrangementsPriceWithoutDiscount={setArrangementsPriceWithoutDiscount}
              setArrangementsDiscount={setArrangementsDiscount}
              setOnFocus={setOnFocus}
              windowSize={windowSize}
              isMobileBrowser={isMobileBrowser}
              deletedProducts={deletedProducts}
              setDeletedProducts={setDeletedProducts}
            />
            <UserData
              form={form}
              register={register}
              setSelectValue={setSelectValue}
              setOnFocus={setOnFocus}
              defaultValue={defaultValue}
              errors={errors}
              display={step === 1}
            />
            <DropPoint display={step === 2} text={form.delivery.name} />
            <UserAddress
              form={form}
              register={register}
              setSelectValue={setSelectValue}
              setOnFocus={setOnFocus}
              defaultValue={defaultValue}
              errors={errors}
              display={step === 3}
            />
            {step === 4 && (
              <PayPalComponent
                amount={SHIPPING_COST + arrangementsPrice}
                transactionComplete={transactionComplete}
                formValues={formValues}
              />
            )}
            {step < 4 && (
              <>
                {step === 0 && <div style={{ paddingTop: fixButtonPosition ? "30px" : "160px" }}></div>}
                {step === 1 && <div style={{ paddingTop: fixButtonPosition ? "0" : "130px" }}></div>}
                {(step === 2 || step === 3) && <div style={{ paddingTop: fixButtonPosition ? "0" : "100px" }}></div>}
                <div
                  className="form__form-summary"
                  style={{
                    position: `${fixButtonPosition ? "relative" : "fixed"}`,
                    padding: `${fixButtonPosition ? "initial" : "auto"}`,
                    // bottom: `${fixButtonPosition && step !== 0 ? "-60vw" : "0"}`,
                  }}
                >
                  <div className="form__form-sumary-total-container">
                    <div className="form__form-sumary-cost-container">
                      {arrangementsPrice > 0 && (
                        <>
                          <div className="form__form-sumary-flex">
                            <div>{getRepairsPriceName()}</div>
                            <div>
                              {" "}
                              {form.withDiscount
                                ? arrangementsPriceWithoutDiscount.toFixed(2)
                                : arrangementsPrice.toFixed(2)}{" "}
                              {currency}
                            </div>
                          </div>
                          {form.withDiscount && arrangementsDiscount !== 0 && (
                            <div className="form__form-sumary-flex">
                              <div>{translate("summary.discount")}</div>
                              <div>
                                {" -"}
                                {arrangementsDiscount.toFixed(2)} {currency}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      <div className="form__form-sumary-flex">
                        <div>{translate("delivery")}</div>
                        <div>
                          {SHIPPING_COST.toFixed(2)} {currency}
                        </div>
                      </div>
                    </div>
                    <div className="form__form-sumary-flex">
                      <div style={{ fontWeight: "500" }}>{translate("total")}</div>
                      <div style={{ fontWeight: "500" }}>
                        {(SHIPPING_COST + arrangementsPrice).toFixed(2)} {currency}
                      </div>
                    </div>
                    <div className="form__form-vat-flex">
                      <div>{translate("vat")}</div>
                    </div>
                  </div>
                  <Button form={form} disabled={disabled} isApp={getIsApp()} />
                </div>
              </>
            )}
            {step === 5 && <FinalStep dataPaypal={dataPaypal} startAgain={startAgain} />}
          </form>
          <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            onAfterOpen={afterOpenModal}
            ariaHideApp={false}
            className="help-modal__modal"
            overlayClassName="help-modal__overlay"
          >
            <div className="help-modal__container">
              <div className="help-modal__title">{translate("help.instructions")}</div>
              <div className="help-modal__list">
                <div className="help-modal__card" onClick={() => window.open(`tel:${translate("help.phone")}`)}>
                  <div>
                    <img src={IcoPhone} alt="phone" />
                  </div>
                  <div>
                    <div className="help-modal__card_title">{`${translate("help.call")} ${translate(
                      "help.phone"
                    )}`}</div>
                    <div className="help-modal__card_text">
                      <p>{translate("help.opening1")}</p>
                      <p>{translate("help.opening2")}</p>
                    </div>
                  </div>
                  <div>
                    <img src={ArrowHelp} alt="go" />
                  </div>
                </div>
                <a
                  className="help-modal__card"
                  href={`https://wa.me/${translate("whatsapp.phone")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>
                    <img src={whatsapp} alt="whatsapp" />
                  </div>
                  <div>
                    <div className="help-modal__card_title">WHATSAPP</div>
                    <div className="help-modal__card_text">
                      <p>{translate("whatsapp.opening1")}</p>
                      <p>{translate("whatsapp.opening2")}</p>
                    </div>
                  </div>
                  <div>
                    <img src={ArrowHelp} alt="go" />
                  </div>
                </a>
                <a
                  className="help-modal__card"
                  href="https://www.facebook.com/ZARACare"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>
                    <img src={IcoFacebook} alt="chat" />
                  </div>
                  <div>
                    <div className="help-modal__card_title">FACEBOOK</div>
                    <div className="help-modal__card_text">ZARACARE</div>
                  </div>
                  <div>
                    <img src={ArrowHelp} alt="go" />
                  </div>
                </a>

                <a
                  className="help-modal__card"
                  href="https://twitter.com/ZARA_Care"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>
                    <img src={IcoTwitter} alt="chat" />
                  </div>
                  <div>
                    <div className="help-modal__card_title">TWITTER</div>
                    <div className="help-modal__card_text">@ZARA_CARE</div>
                  </div>
                  <div>
                    <img src={ArrowHelp} alt="go" />
                  </div>
                </a>
              </div>
              <div className="help-modal__close" onClick={closeModal}>
                <img src={Close} alt="close" />
              </div>
            </div>
          </ReactModal>
        </>
      )}
    </Fragment>
  );
};

export default Form;
